import { type ReactNode, useState } from "react";

import { CreativeImage } from "../styledComponents";

import { ImagePlaceholder } from "./ImagePlaceholder";

type ImageWithFallbackProps = {
    alt: string;
    dataAutomation?: string;
    fallback?: ReactNode;
    src?: string | null;
};

const ImageWithFallbackBase = ({
    src,
    alt,
    fallback = <ImagePlaceholder />,
    dataAutomation = "creative-image",
}: ImageWithFallbackProps) => {
    const [hasError, setHasError] = useState(false);

    if (!src || hasError) {
        return fallback;
    }

    return (
        <CreativeImage
            loading="lazy"
            src={src}
            alt={alt}
            data-automation={dataAutomation}
            onError={() => setHasError(true)}
        />
    );
};

export const ImageWithFallback = (props: ImageWithFallbackProps) => (
    <ImageWithFallbackBase
        key={props.src || "image-with-fallback"}
        {...props}
    />
);
